import { createCrewLookupSelect } from './createCrewLookupSelect';

/** Active nationalities, ordered by sortOrder. */
export const NationalitySelect = createCrewLookupSelect('NationalitySelect', 'nationalities');
export default NationalitySelect;
